import {
  GET_REPORTS_FAILED,
  GET_REPORTS_REQUESTED,
  GET_REPORTS_SUCCEEDED,
  SET_SELECTED_REPORT_ID
} from 'store/Reports/constants'
import { stringWithoutSpecialCharacters } from 'utils/stringWithoutSpecialCharacters'

const initialState = {
  byId: {},
  isLoading: false,
  selectedReportId: null
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_REPORTS_REQUESTED: {
      return {
        ...state,
        isLoading: true
      }
    }

    case GET_REPORTS_SUCCEEDED: {
      const trasformedPayloadKeys = Object.keys(payload).reduce((result, key) => {
        const value = payload[key]
        const newKey = stringWithoutSpecialCharacters(key)

        return { ...result, [newKey]: value }
      }, {})

      return {
        ...state,
        isLoading: false,
        byVenue: trasformedPayloadKeys
      }
    }

    case GET_REPORTS_FAILED: {
      return {
        ...state,
        error: payload,
        isLoading: false
      }
    }

    case SET_SELECTED_REPORT_ID: {
      return {
        ...state,
        selectedReportId: payload
      }
    }

    default:
      return state
  }
}
